import React, { Component } from "react";
import commonUtil from "../../../../../../../utils/commonUtil";
import * as giftListActions from "../../../actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { getMessagesService, getAllMessagesService, addThankYouMessage, getRegisteredGiftList } =
  giftListActions;

class ChatMessageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      hideButton: false,
      repliedMessage: "",
    };
  }
  selectedProduct = this.props.selectedProduct;

  componentDidMount() {
    this.setState({ message: "", repliedMessage: "", hideButton: false });
  }

  UNSAFE_componentWillMount() {
    this.props.getMessagesService(
      this.props.eventId,
      this.selectedProduct.purchaseItemId
    );
  }

  sendThankyouMessage = (purchaseItemId, newMessage) => {
    const message = newMessage;

    addThankYouMessage(this.props.eventId, purchaseItemId, message, "").then(
      (response) => {
        if (response?.body?.status?.status === "success") {
          const sortingValue = this.props.sortingValue || undefined;
          const filterParams = this.props.filterParams || [];
          const currentPage = this.props.currentPage || 1;
          this.props.getRecievedGiftList(
            "",
            sortingValue,
            filterParams,
            currentPage
          );

          this.selectedProduct.messageInfo = "replied";
          this.props.getAllMessagesService(
            this.props.eventId,
          );
        }
      }
    );
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ message: value }, () => {
      if (this.textarea) {
        this.textarea.style.height = "auto";
        this.textarea.style.height = this.textarea.scrollHeight + "px";
      }
    });
  };

  handleSend = () => {
    const { message } = this.state;
    const purchaseItemId = this.selectedProduct.purchaseItemId;

    if (message.trim()) {
      const userMessage = message;
      this.sendThankyouMessage(purchaseItemId, userMessage);
      this.setState({
        repliedMessage: userMessage,
        message: "",
        hideButton: true,
      });
    }
  };

  messageLengthValidation = (e) => {
    if (e.target.value.length >= 300 && e.keyCode !== 8) {
      e.target.value = e.target.value.slice(0, 300);
    }
  };

  render() {
    const { message, hideButton, repliedMessage } = this.state;
    const { messages, lables } = this.props;

    return (
      <div id="chat-message-modal" className="chat-modal-overlay">
        <div className="chat-modal">
          {/* Header */}
          <div className="chat-modal-header">
            <div className="chat-modal-header-left">
              <div
                className="chat-back-icon"
                onClick={this.props.handleBackModalOverlay}
              >
                <span className="icon-flecha_header_izquierda chat-pointer" />
              </div>
              <div className="chat-title-wrapper">
                <div className="chat-title">{commonUtil.getLabel(
                     lables.EventAdminPage,
                     "adminpage.regalosrecibidos.replymessage.button"
                   )}</div>
              </div>
            </div>
            <div className="chat-modal-header-right">
              <div
                className="chat-close-icon"
                onClick={this.props.hideModalOverlay}
              >
                <img
                  src={commonUtil.getAssetURL() + "/images/close_white.svg"}
                  alt=""
                  className="icon_vozcliente chat-pointer"
                />
              </div>
            </div>
          </div>

          {/* Message content */}
          <div className="chat-body">
            <div className="message-bubble">
              <div className="message-text">
                {messages.customMessage
                  ? messages.customMessage
                  : commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.deafult.message"
                  )}
              </div>
            </div>

            {hideButton && repliedMessage && (
              <div className="message-bubble right">
                <div className="message-text">{repliedMessage}</div>
              </div>
            )}
          </div>

          {hideButton && repliedMessage ? (
            <div className="empty-field"></div>
          ) : (
            <div className="chat-input-wrapper">
              <div className="chat-input-box">
                <textarea
                  ref={(el) => (this.textarea = el)}
                  className="chat-input-field"
                  placeholder="Escribe un mensaje"
                  value={message}
                  onChange={this.handleChange}
                  rows={1}
                  id="sendMessage"
                  onKeyUp={(e) => this.messageLengthValidation(e)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      this.handleSend();
                    }
                  }}
                  maxLength={300}
                />
                <div className="chat-send-wrapper">
                  <button className="chat-send-btn" onClick={this.handleSend}>
                    <img
                      src={commonUtil.getAssetURL() + "/images/send.svg"}
                      alt="Send"
                      className="chat-pointer"
                    />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  messages: state.giftList.data.messageInfo,
  messageLoaded: state.giftList.messageLoaded,
});
const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMessagesService,
      getAllMessagesService,
      getRegisteredGiftList,
    },
    dispatch
  );

export default connect(mapStateToProps, matchDispatchToProps)(ChatMessageModal);
